<template>
     <Breadcrumbs main="Email" title="Email Compose" />
      <div class="container-fluid">
            <div class="email-wrap">
              <div class="row">
                  <emailSidebar />
                  <emailCompose/>
              </div>
              </div>
      </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const emailSidebar = defineAsyncComponent(() => import("@/components/commen/emailSidebar.vue"))
const emailCompose = defineAsyncComponent(() => import("@/components/theme/email/compose/emailCompose.vue"))

</script>